import { render } from "./Collaborators.vue?vue&type=template&id=46b5f8a8&scoped=true"
import script from "./Collaborators.vue?vue&type=script&lang=js"
export * from "./Collaborators.vue?vue&type=script&lang=js"

import "./Collaborators.vue?vue&type=style&index=0&id=46b5f8a8&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b5f8a8"]])

export default __exports__